<template>
  <section class="content_section">
    <form class="modules-grid" style="padding: 20px;" v-if="renderComp">
      <div v-for="(mod, index) in modules" :key="index" class="modul-group">
        <md-field
            class="modul"
        >
          <p class="modul_name">
            <span>
              <md-icon>mode_standby</md-icon>
            </span>
            {{ mod.allias || mod.name }}
          </p>

          <!-- switch remains interactive -->
          <md-switch
              v-model="mod.status"
              @change="switchModule(mod.name, mod.status)"
              :class="`md-primary switcher${!mod.active ? ' disabled' : ''}`"
              :disabled="!mod.active"
          />
        </md-field>

        <!-- Always open description under the field; gear (settings) sits on
             the right, centered vertically, for modules that carry settings. -->
        <div class="inline-drawer">
          <div class="inline-drawer-desc" v-html="mod.description"></div>
          <md-button
              class="md-icon-button modul-gear"
              :class="{ 'modul-gear--disabled': !hasSettings(mod) }"
              :disabled="!hasSettings(mod)"
              @click="openSettings(mod)"
          >
            <md-icon>settings</md-icon>
          </md-button>
        </div>
      </div>
    </form>

    <ModuleSettingsDialog
        :options="options"
        :module="settingsModule"
        :show.sync="showSettingsDialog"
        @saved="onSettingsSaved"
    />

    <Success :options="options" />
  </section>
</template>

<script>
import * as moment from 'moment'
import Success from '../../components/dialogs/Success.vue'
import ModuleSettingsDialog, { SETTING_DEFS_BY_MODULE } from '../../components/dialogs/ModuleSettingsDialog.vue'

export default {
  name: 'settings',
  components: { Success, ModuleSettingsDialog },
  props: {
    options: { type: Object, required: true }
  },
  data() {
    return {
      renderComp: false,
      modules: [],
      // Gear-icon settings dialog state.
      showSettingsDialog: false,
      settingsModule: null
      // removed expandedIndex; drawer is always open
    }
  },
  created() {
    this.getModules()
  },
  mounted() {
    if (this.options.currentRoute !== 'Brandings') {
      this.options.showBrandForm = false
    }
  },
  methods: {
    // A module exposes a settings panel when its `settings` JSON is present and
    // non-empty. settings may arrive as a parsed object or a JSON string.
    hasSettings(mod) {
      // A module exposes a settings panel only when the dialog defines editable
      // toggles for it (SETTING_DEFS_BY_MODULE). We intentionally do NOT key off
      // the stored `settings` JSON: a module may still carry legacy keys in the DB
      // (e.g. invoice_checkout, whose toggles moved to Checkout Profiles) that no
      // longer have any UI — gating on those would open an empty dialog.
      const name = mod && mod.name
      const defs = name && SETTING_DEFS_BY_MODULE[name]
      return Array.isArray(defs) && defs.length > 0
    },
    openSettings(mod) {
      if (!this.hasSettings(mod)) return
      this.settingsModule = mod
      this.showSettingsDialog = true
    },
    onSettingsSaved(settings) {
      // Reflect the saved settings back onto the in-memory module row so the
      // gear panel reopens with the latest values without a full reload.
      if (this.settingsModule) {
        this.$set(this.settingsModule, 'settings', settings)
      }
    },
    // removed toggleExpand; not needed anymore
    async switchModule(modul, status) {
      let self = this
      let updateData = { newModul: modul, newStatus: status === true ? 1 : 0 }
      let success = false
      await self.doPost({ data: updateData }, 'updateModul', function (res) {
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true)
        } else {
          success = true
        }
      })
      if (success) {
        this.$emit('update:options', { ...this.options, [modul]: status })
        self.modules.forEach(mod => {
          if (mod.name === 'helloEdit' && mod.status === false) {
            self.doPost({}, 'removeHello', function (res) {
              if (res.data.status === 'error') {
                self.help.log(self.$t(res.msg), false, true)
              } else {
                self.renderComponent = true
              }
            })
          }
          if (
              mod.status === false &&
              (mod.name === 'helloEdit' || mod.name === 'kommentare' || mod.name === 'zusatzinfos')
          ) {
            self.setPdfStatus()
          }
        })
        // Page-break layout changes the PDF in BOTH directions, so cached
        // PDFs must regenerate on enable and on disable alike.
        if (modul === 'pdf_no_page_breaks') {
          self.setPdfStatus()
        }
      }
    },
    async setPdfStatus() {
      let self = this
      let data = { tripId: 'all', status: 'false' }
      await this.doPost({ data: data }, 'setStatusPdf', function (res) {
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true)
        } else {
          let result = res.data.data
        }
      })
    },
    getModules() {
      this.renderComp = false
      let self = this
      self.modules = []
      self.doPost({}, 'getmodules', function (res) {
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true)
        } else {
          let result = res.data.data
          for (let i = 0; i < result.length; i++) {
            result[i].status = result[i].status == 1 ? true : false
            self.modules.push(result[i])
          }
          self.renderComp = true
        }
      })
    }
  }
}
</script>

<style scoped>
.switcher {
  padding-top: 0.85rem;
}

.modul-gear {
  margin: 0;
  flex-shrink: 0;
}
.modul-gear--disabled {
  opacity: 0.35;
  cursor: not-allowed;
}

/* grid layout: two modules per row */
.modules-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  grid-gap: 16px;
}
@media (max-width: 900px) {
  .modules-grid {
    grid-template-columns: 1fr; /* stack on small screens */
  }
}

.modul-group {
  width: 100%;
}
.modul {
  width: 100%;
  height: 5rem;
  background-color: white;
  border-radius: 1rem, 1rem, 0, 0;
  display: flex;
  padding-left: 3rem;
  padding-right: 3rem;
  padding-top: 0;
  justify-content: space-between;
  margin-bottom: 0 !important;
  box-sizing: border-box;
}
.modul p {
  font-size: 18px;
  font-weight: 100;
  align-self: center;
}
.modul_name {
  min-width: 20%;
}

/* inline drawer under field: same width as its grid cell, scroll when content is long */
.inline-drawer {
  width: 100% !important;
  box-sizing: border-box;
  background: #f7f7f7;
  border-radius: 0 0 1rem 1rem;
  border-top: 1px solid #eee;
  box-shadow: 0 4px 16px rgba(0,0,0,0.10);
  margin-bottom: 1.5rem;
  padding: 1.2rem 3rem; /* align with field padding */
  max-height: 220px;
  overflow-y: auto;
  /* row: description grows, gear pinned right and vertically centered */
  display: flex;
  align-items: center;
  gap: 1rem;
}
.inline-drawer-desc {
  flex: 1 1 auto;
  min-width: 0;
}

/* transition classes kept for possible future use */
.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all .18s cubic-bezier(.4,0,.2,1);
}
.slide-fade-enter,
.slide-fade-leave-to {
  opacity: 0;
  transform: translateY(-6px);
}
.disabled {
  pointer-events: none;
  opacity: 0.6;
}
</style>
